import React from 'react';
import PropTypes from 'prop-types';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import ModalRouter from './ModalRouter';

const Root = ({ store, routes, history, modals }) => (
  <Provider store={store}>
    <div>
      <Router history={history}>{routes}</Router>
      {modals ? <ModalRouter modals={modals} /> : null}
    </div>
  </Provider>
);

Root.displayName = 'Root';

Root.propTypes = {
  store: PropTypes.object.isRequired,
  routes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default Root;
